(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
      
  document.addEventListener("DOMContentLoaded", () => {
    const announcement_section = document.getElementById('shopify-section-announcement-bar');
    const announcement_bar = document.querySelector('.announcement-bar');
    const announcementClosed = sessionStorage.getItem("announcementClosed");

    document.querySelector('.announcement-bar__close').addEventListener('click', (event) => {
        console.log('close clicked');
      document.getElementById('MainContent').style.setProperty("transition", "var(--duration-short) ease");
      announcement_bar.classList.add('hidden');
      measureOffset();
      sessionStorage.setItem("announcementClosed", "true");
        console.log('logged in session storage');
    });

    if (announcement_bar.classList.contains('scroll-left') || window.innerWidth < 750) {
        console.log('conditions met');
      const announcement_content = document.querySelector('.announcement-bar__content:first-of-type');
      let announcementRepeat = 0;
  
      function announcementScroll() {
          console.log('Announcement Scroll function triggered');
        let announcementWidth = announcement_content.scrollWidth; // gets the width of the main content wrapper
          console.log('announcement width: ' + announcementWidth);
        let viewportWidth = window.innerWidth;
          console.log('viewport width: ' + viewportWidth);
        let currentRepeat = announcementRepeat;
          console.log('current repeat: ' + announcementRepeat);
        let newRepeat = Math.ceil(viewportWidth / announcementWidth); // divides viewport width by content width and rounds up to determine how many times it should be cloned
          console.log('new repeat: ' + announcementRepeat);
  
        if (newRepeat > currentRepeat) {
          announcementRepeat = newRepeat;
            console.log('new repeat greater than current, repeat now: ' + announcementRepeat);
          newRepeat = parseInt(newRepeat) - parseInt(currentRepeat);
            console.log('adding: ' + newRepeat);
          // appends clones of the main content (that are hidden from screen readers) to the announcement bar to prevent any gaps in scrolling
          for (let i = 0; i < newRepeat; i++) {
            let announcement_clone = announcement_content.cloneNode(true);
            announcement_clone.setAttribute('aria-hidden', 'true');
            document.querySelector('.announcement-bar__wrapper').appendChild(announcement_clone);
              console.log('appended ' + i);
          }
        }
    
        // these styles are used to calculate the animation speed, which allows content to be changed without affecting the chosen speed
        announcement_bar.style.setProperty('--announcement-content-width', announcementWidth);
        announcement_bar.style.setProperty('--announcement-repeat', announcementRepeat);
      
        // sets a media query with the current width so that we can check if the announcement bar content needs to be added to if the width increases
        let announcement_mq = window.matchMedia('(max-width: ' + viewportWidth + 'px)');
        announcement_mq.addEventListener('change', (e) => announcementScroll());
      }
  
      if(announcementClosed === 'true'){
        document.getElementById('MainContent').style.setProperty("transition", "var(--duration-long) ease");
        announcement_bar.classList.add('hidden');
        measureOffset();
      } else {
        announcementScroll();
      }
    } else {
      if(announcementClosed === 'true'){
        document.getElementById('MainContent').style.setProperty("transition", "var(--duration-long) ease");
        announcement_section.classList.add('hidden');
        measureOffset();
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-grid"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    // Loops through campaign grids and adds an incremental class to identify them then initialises a slick slider (prevents them from controlling each other)
    var cgsNum = 0;
    $('.campaign-grid-carousel').each(function(i, obj) {
      cgsNum++;
      $(this).addClass('cgs' + cgsNum);
      $(this).slick({
        lazyLoad: 'ondemand',
        speed: 300,
        easing: 'ease',
        adaptiveHeight: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: false,
        prevArrow: '<button type="button" class="slick-prev visually-hidden" aria-label="Previous Slide"></button>',
        nextArrow: '<button type="button" class="slick-next visually-hidden" aria-label="Next Slide"></button>',
        asNavFor: '.campaign-grid_slider-dots.cgd' + cgsNum
      });
    });
    // Does the same with the dot navigation
    var cgdNum = 0;
    $('.campaign-grid_slider-dots').each(function(i, obj) {
      cgdNum++;
      $(this).addClass('cgd' + cgdNum);
      $(this).slick({
        speed: 300,
        easing: 'ease',
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: false,
        asNavFor: '.campaign-grid-carousel.cgs' + cgdNum,
        centerMode: true,
        focusOnSelect: true,
        centerPadding: '10%'
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-order"] && !Shopify.designMode) return;
  try {
    
  //Slick fabric photos
  $(document).ready(function() {
    $('.ContactForm-fabric-photos').slick({
      autoplay: false,
      infinite: true,
      speed: 500,
      initialSlide: 0,
      fade: true,
      easing: 'ease-out',
      dots: false,
      arrows: false,
      adaptiveHeight: false,
      touchMove: false
    });
    if ($(window).width() > 749) {
      $('.custom__wrapper details').each(function() {
        $(this).attr('open','true');
      });
      $('.custom__wrapper summary').each(function() {
        $(this).attr('aria-expanded','true');
        $(this).attr('tabindex','-1');
      });
    }
  });

  $(window).resize(function() {
    if ($(window).width() > 749) {
      $('.custom__wrapper details').each(function() {
        $(this).attr('open','true');
      });
      $('.custom__wrapper summary').each(function() {
        $(this).attr('aria-expanded','true');
        $(this).attr('tabindex','-1');
      });
    }
  });
    
  // Scroll to first slide after it's been changed to variant image on colour selection
  $(function() {
	$('#available_fabrics').change(function() {
      var slidevalue = $(this).children("option:selected").val();
  	  $('.ContactForm-fabric-photos').slick('slickGoTo', slidevalue - 1);
      return false;
	});
  });
  
  // Create additional style fields
  $(function() {
    var fieldnumber = 1;
    $('#add_another').click(function() {
      fieldnumber += 1;
      var labelstyle = "ContactForm-style" + fieldnumber;
      var textstyle = "Style #" + fieldnumber + " *";
      var namestyle = "contact[style" + fieldnumber + "]";
      var idstyle = "ContactForm-style" + fieldnumber;
      var labelfabric = "ContactForm-fabric" + fieldnumber;
      var textfabric = "Fabric #" + fieldnumber + " *";
      var namefabric = "contact[fabric" + fieldnumber + "]";
      var idfabric = "ContactForm-fabric" + fieldnumber;
      var labelcustomisation = "ContactForm-customisation" + fieldnumber;
      var textcustomisation = "Customisation #" + fieldnumber;
      var namecustomisation = "contact[customisation" + fieldnumber + "]";
      var idcustomisation = "ContactForm-customisation" + fieldnumber;
      $( '<div class="field"><input type="text" value="" name="'+namestyle+'" id="'+idstyle+'" class="field__input" placeholder="'+textstyle+'" required /><label for="'+labelstyle+'" class="field__label">'+textstyle+'</label></div><div class="field"><input type="text" value="" name="'+namefabric+'" id="'+idfabric+'" class="field__input" placeholder="'+textfabric+'" required /><label for="'+labelfabric+'" class="field__label">'+textfabric+'</label></div><div class="field"><textarea name="'+namecustomisation+'" id="'+idcustomisation+'" class="text-area field__input" rows="10" placeholder="'+textcustomisation+'"></textarea><label for="'+labelcustomisation+'" class="form__label field__label">'+textcustomisation+'</label></div>' ).insertBefore( $(".contact__button-wrapper") );
	});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  window.fd('form', {
    formId: '634bd5ec22362ce13d823126',
    containerEl: '#fd-form-634bd5ec22362ce13d823126'
  });
  
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  $(document).ready(function() {
    //mobile menu drawer submenu function
    $('.mobile-menu__button').click(function () {
      if ($(this).hasClass('expanded-menu')) {
        $(this).removeClass('expanded-menu');
        $(this).next().attr('aria-expanded', false);
        $(this).next().addClass('hidden'); //hides the next element after the button, which will be its menu
      } else {
        $(this).next().removeClass('hidden'); //displays the next element after the button, which will be its menu
        //waits a very short period after hidden class (display: none;) is removed, so that animations will work
        setTimeout(() => {
          $(this).addClass('expanded-menu');
          $(this).siblings('.mobile-menu__content').attr('aria-expanded', true);
        }, 20);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  jQuery(document).ready( function( $ ) {
    function doMasonry() {
      var $grid = $( ".mason" ).imagesLoaded(function () {
        $grid.masonry({
          itemSelector: '.lingerie-in-film',
          columnWidth: '.lingerie-in-film',
          percentPosition: true,
          originLeft: false,
          gutter: 20
        });
      });
    }
    
    $( window ).resize( function() {
      doMasonry();
    });
    doMasonry();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  $(document).ready(function () {
    // Loops through the product cards and creates a slider for each
    var card = 0;
    $('.media.slick').each(function(i, obj) {
      card++
      $(this).slick({
        lazyLoad: 'ondemand',              
        speed: 300,
        easing: 'ease',
        adaptiveHeight: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: false,
        prevArrow: '<button type="button" class="slick-prev visually-hidden-device" aria-label="Previous Slide"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" fill="currentColor"></path></svg></button>',
        nextArrow: '<button type="button" class="slick-next visually-hidden-device" aria-label="Next Slide"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" fill="currentColor" transform="translate(100, 100) rotate(180)"></path></svg></button>'
      });
    });
  
    $('.card-wrapper').each(function(i, obj) {
      $(this).delay(i*200).queue(function() {
        $(this).addClass('loaded').dequeue();
      });
    });
  
    // Gets width of the collection grid column and stores it in a variable, it's used to set a height value on 'a.slick-slide' so that 'object-fit: cover;' works correctly on images
    $(window).resize(function() {
      $(':root').css("--collection-grid-width", 
      $(".grid__item").width() + "px");
    }).resize();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-drawer"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    const $newsletterDrawer = $('#NewsletterDrawer__wrapper');
    let $pageScroll = 600;

    $(window).scroll(function() {
      // checks if localStorage value has expired then returns null or a "true" value
      let $newsletterClosed = getWithExpiry("newsletterClosed");
      // if value isn't "true", shows newsletter drawer
      if($newsletterClosed != "true"){
        let $scroll = $(window).scrollTop();
        if($scroll > $pageScroll) {
          $newsletterDrawer.addClass('is-active');
          setTimeout(() => {
            $newsletterDrawer.addClass('is-visible');
          }, 50);
        }
      }
    });
    
    // when newsletter drawer is closed or submit button is clicked sets localStorage value (with a 1 day expiry in ms) that prevents it appearing again
    $('#NewsletterDrawer__wrapper [data-drawer-close], #NewsletterDrawer__wrapper .newsletter-form__button').click(function(){
      setWithExpiry("newsletterClosed", "true", 86400000);
    });
  });
  
  function setWithExpiry(key, value, ttl) {
	const now = new Date()

	// `item` is an object which contains the original value
	// as well as the time when it's supposed to expire
	const item = {
		value: value,
		expiry: now.getTime() + ttl,
	}
    localStorage.setItem(key, JSON.stringify(item))
  }

  function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key)

      // if the item doesn't exist, return null
      if (!itemStr) {
          return null
      }

      const item = JSON.parse(itemStr)
      const now = new Date()

      // compare the expiry time of the item with the current time
      if (now.getTime() > item.expiry) {
          // If the item is expired, delete the item from storage
          // and return null
          localStorage.removeItem(key)
          return null
      }
      return item.value
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  function slickCard() {
    // Loops through the product cards and creates a slider for each
    var card = 0;
    $('.product-recommendations .media.slick').each(function(i, obj) {
      card++
      $(this).slick({
        lazyLoad: 'ondemand',              
        speed: 700,
        easing: 'linear',
        adaptiveHeight: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: false,
        prevArrow: '<button type="button" class="slick-prev visually-hidden-device" aria-label="Previous Slide"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" fill="currentColor"></path></svg></button>',
        nextArrow: '<button type="button" class="slick-next visually-hidden-device" aria-label="Next Slide"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" fill="currentColor" transform="translate(100, 100) rotate(180)"></path></svg></button>'
      });
    });
  }
  
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              slickCard();
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
